import React, { useEffect, useState } from "react";
import { Table, Modal, Form, Input, InputNumber, Button, message, Popconfirm, Card } from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import Service from "../../service";
import { hideAuthLoader } from "../../appRedux/actions";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import "./karma.css";
import "./reward.css";
import EditIcon from "../../assets/images/EditIcon";
import NodataFoundIcon from "../../assets/images/NodataFoundIcon";
import useCompanyDateFormat from "../../hooks/useCompanyDateFormat";
import { TABLE_PAGINATION } from "../../constants/tablePagination";


const CategoryManager = () => {
    const dateFormat = useCompanyDateFormat();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [editId, setEditId] = useState(null);
    const Search = Input.Search;
    const [searchText, setsearchText] = useState("");

    const dispatch = useDispatch()

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleAddCategory = async (values) => {
        try {
            const response = await Service.makeAPICall({
                methodName: editId == null ? Service.postMethod : Service.putMethod,
                api_url: editId == null ? Service.wafflecategry : Service.wafflecategry + '/' + editId,
                body: {
                    category: values?.category,
                    waffle_count: values?.waffle_count
                }
            });
            if (!response.data.success) {
                message.error(response.data.message);

            }
            if (response.data.success) {
                dispatch(hideAuthLoader());
                message.success(response.data.message);
                form.resetFields();
                wafflecategry()
                setIsModalVisible(false)
                setEditId(null)
            }
        } catch (error) {
            console.error("Failed to create category:", error);
        }

    };

    const columns = [
        {
            title: "Waffle Category",
            dataIndex: "category",
            key: "category",
        },
        {
            title: "Waffle Count",
            dataIndex: "waffle_count",
            key: "waffle_count",
        },
        {
            title: "Created Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (text, record) => (
                <>
                    { moment(record?.createdAt).format(dateFormat) }
                </>
            )

        },
        {
            title: "Actions",
            dataIndex: "action",
            render: (text, record) => (
                <div style={ { display: "flex", flexWrap: "wrap" } }>
                    
                    <Button type="link" className="edit"  onClick={ () => {
                                wafflecategryDetail(record._id)
                                setEditId(record._id);
                            } }>
                        <EditIcon />
                    </Button>
                    <Popconfirm
                        className="popconfirm"
                        title="Are you sure to delete?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={ () => wafflecategryDelete(record._id) }
                        style={ { textAlign: 'center' } }
                    >
                        <Button type="link" className="delete">
                            <DeleteOutlined   />
                        </Button>
                    </Popconfirm>
                </div>
            ),
        },
    ];


    const wafflecategry = async () => {
        try {
            const response = await Service.makeAPICall({
                methodName: Service.getMethod,
                api_url: Service.wafflecategry + '?search=' + searchText,
            });

            if (response.status) {
                dispatch(hideAuthLoader());
                setSelectedCategories(response?.data?.data)
            }
        } catch (error) {
            console.error("Failed to fetch rewards:", error);
        }
    };
    const wafflecategryDetail = async (id) => {
        try {
            const response = await Service.makeAPICall({
                methodName: Service.getMethod,
                api_url: Service.wafflecategry + '/' + id,
            });
            if (response.data.success) {
                dispatch(hideAuthLoader());
                form.setFieldsValue({
                    waffle_count: response?.data?.data?.waffle_count,
                    category: response?.data?.data?.category
                });
                showModal()
            }
        } catch (error) {
            console.error("Failed to fetch rewards:", error);
        }
    };


    const wafflecategryDelete = async (id) => {
        try {
            const response = await Service.makeAPICall({
                methodName: Service.deleteMethod,
                api_url: Service.wafflecategry + '/' + id,
            });
            if (response.data.success) {
                dispatch(hideAuthLoader());
                message.success("Waffle Category Deleted");
                wafflecategry()
            }
        } catch (error) {
            console.error("Failed to fetch rewards:", error);
        }
    };
    useEffect(() => {
        wafflecategry()

    }, [])
    return (

        <Card className='karma-card-wrapper'>
            <div className=" inout-header text-left">
                <h2>Waffle Category </h2>

            </div>
            <Card className="main-content-wrapper" >

                <div className="search-wrapper">
                    <Search
                        placeholder="Search..."
                        onSearch={ wafflecategry }
                        onChange={ (e) => { setsearchText(e.target.value) } }
                        //   onKeyUp={ resetSearchFilter }
                        style={ { width: 200 } }
                        className="mr2"
                    />
                    <div className="filter-btns-wrapper">
                        <Button type="primary" icon={<PlusOutlined />} onClick={ showModal } className="redeem-button">
                            Waffle Category
                        </Button>
                    </div>
                </div>
                <div className='main-table-wrapper'>

                    { console.log("selectedCategories", selectedCategories) }
                    <Table dataSource={ selectedCategories }   locale={ { emptyText: <NodataFoundIcon/> } } columns={ columns } rowKey="category"
                        pagination={{ ...TABLE_PAGINATION }}
                        footer={ () => { return `Total Categories ${selectedCategories?.length}` } } />
                </div>
            </Card>

            <Modal
                title={ `${editId == null ? "Add" : "Update"} Category` }
                visible={ isModalVisible }
                onCancel={ () => { setIsModalVisible(false); form.resetFields(); setEditId(null) } }
                footer={ [
                    <>
                       <Button className="ant-delete"  onClick={()=>form.submit()}>
                          Cancel
                        </Button>
                    <Button type="primary" htmlType="submit" onClick={()=>form.submit()}>
                            { editId == null ? "Save" : "Update" } 
                        </Button>
                    </>
                ] }
            >
                <Form form={ form } onFinish={ handleAddCategory } layout="vertical">
                    <Form.Item
                        label="Category"
                        name="category"
                        rules={ [{ required: true, message: "Please enter a category name" }] }
                    >
                        <Input placeholder="Enter category name" />
                    </Form.Item>

                    <Form.Item
                        label="Waffle Count"
                        name="waffle_count"
                        rules={ [{ required: true, message: "Please enter a waffle count" }] }
                    >
                        <InputNumber min={ 1 } style={ { width: "100%" } } placeholder="Enter waffle count" />
                    </Form.Item>

                    <Form.Item>
                        
                    </Form.Item>
                </Form>
            </Modal>
        </Card>

    );
};

export default CategoryManager;
